import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, withKeys as _withKeys, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-843341ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_2 = { style: {"font-style":"italic"} }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = { style: {"font-style":"italic"} }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = { style: {"font-style":"italic"} }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  style: {"font-style":"italic","color":"#a59cd3","font-size":"30px"},
  class: "mt-10 mb-10 text-left"
}, " Learn smart, not hard! ", -1))
const _hoisted_8 = { class: "mt-5" }
const _hoisted_9 = { class: "d-flex flex-column align-center" }
const _hoisted_10 = { class: "mt-5" }
const _hoisted_11 = { style: {"margin-right":"30px"} }
const _hoisted_12 = { style: {"margin-right":"30px"} }
const _hoisted_13 = { style: {"margin-right":"30px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DailyMilestoneBar = _resolveComponent("DailyMilestoneBar")!
  const _component_AlertError = _resolveComponent("AlertError")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_responsive = _resolveComponent("v-responsive")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "my-container" }, {
    default: _withCtx(() => [
      (_ctx.isLoggedIn)
        ? (_openBlock(), _createBlock(_component_DailyMilestoneBar, { key: 0 }))
        : _createCommentVNode("", true),
      _createVNode(_component_AlertError, {
        modelValue: _ctx.showAlert,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showAlert) = $event)),
        message: _ctx.alertMessage
      }, null, 8, ["modelValue", "message"]),
      _createVNode(_component_v_row, {
        class: _normalizeClass({ 'center-content': _ctx.isLoggedIn })
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            md: _ctx.isLoggedIn ? '12' : '8',
            order: "2",
            "order-sm": "2",
            "order-md": "1",
            "order-lg": "1"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, { variant: "elevated" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_title, { style: {"display":"flex","justify-content":"center","flex-wrap":"wrap"} }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("homeView.cardTitle")), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_row, { style: {"display":"flex","justify-content":"space-between","margin-bottom":"2px"} }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { style: {"display":"flex","flex-direction":"column","align-items":"center"} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_img, {
                            src: "/img1.jpg",
                            width: "200"
                          }),
                          _createElementVNode("div", null, [
                            _createElementVNode("p", null, [
                              _createElementVNode("b", null, _toDisplayString(_ctx.$t("homeView.card1.line1")), 1)
                            ]),
                            _createElementVNode("p", null, [
                              _createElementVNode("b", null, _toDisplayString(_ctx.$t("homeView.card1.line2")), 1)
                            ]),
                            _hoisted_1,
                            _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t("homeView.card1.line3")), 1)
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, { style: {"display":"flex","flex-direction":"column","align-items":"center"} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_img, {
                            src: "/img2.jpg",
                            width: "200"
                          }),
                          _createElementVNode("div", null, [
                            _createElementVNode("p", null, [
                              _createElementVNode("b", null, _toDisplayString(_ctx.$t("homeView.card2.line1")), 1)
                            ]),
                            _createElementVNode("p", null, [
                              _createElementVNode("b", null, _toDisplayString(_ctx.$t("homeView.card2.line2")), 1)
                            ]),
                            _hoisted_3,
                            _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("homeView.card2.line3")), 1)
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, { style: {"display":"flex","flex-direction":"column","align-items":"center"} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_img, {
                            src: "/img3.jpg",
                            width: "200"
                          }),
                          _createElementVNode("div", null, [
                            _createElementVNode("p", null, [
                              _createElementVNode("b", null, _toDisplayString(_ctx.$t("homeView.card3.line1")), 1)
                            ]),
                            _createElementVNode("p", null, [
                              _createElementVNode("b", null, _toDisplayString(_ctx.$t("homeView.card3.line2")), 1)
                            ]),
                            _hoisted_5,
                            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("homeView.card3.line3")), 1)
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, { to: "/register" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    variant: "elevated",
                    class: "text-none font-weight-bold mt-6 mb-6"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("homeView.registerButton")), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _hoisted_7
            ]),
            _: 1
          }, 8, ["md"]),
          (!_ctx.isLoggedIn)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 0,
                cols: "12",
                md: "4",
                sm: "12",
                order: "1",
                "order-sm": "1",
                "order-md": "2",
                "order-lg": "2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, { variant: "elevated" }, {
                    default: _withCtx(() => [
                      _createElementVNode("h3", _hoisted_8, _toDisplayString(_ctx.$t("homeView.loginCard.title")), 1),
                      _createVNode(_component_v_responsive, {
                        class: "mx-auto mt-5",
                        "max-width": "290"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            modelValue: _ctx.email,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.email) = $event)),
                            "hide-details": "auto",
                            label: _ctx.$t('homeView.loginCard.emailLabel'),
                            placeholder: "johndoe@gmail.com",
                            type: "email",
                            autofocus: "",
                            class: "mb-5"
                          }, null, 8, ["modelValue", "label"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_responsive, {
                        class: "mx-auto",
                        "max-width": "290"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            modelValue: _ctx.password,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.password) = $event)),
                            label: _ctx.$t('homeView.loginCard.passwordLabel'),
                            type: "password",
                            hint: "",
                            onKeyup: _withKeys(_ctx.login, ["enter"]),
                            class: "mb-2"
                          }, null, 8, ["modelValue", "label", "onKeyup"])
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_9, [
                        _createVNode(_component_v_btn, {
                          class: "text-none mx-auto mb-2",
                          style: {"width":"290px"},
                          onClick: _ctx.login
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("homeView.loginCard.loginButton")), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"]),
                        _createVNode(_component_router_link, { to: "/forgotPassword" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_btn, {
                              class: "text-none mx-auto mb-2",
                              style: {"width":"290px"}
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("homeView.loginCard.forgotPasswordButton")), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_router_link, {
                          to: "/register",
                          class: "mb-4"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("homeView.loginCard.noAccountLink")), 1)
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["class"]),
      _createElementVNode("h2", _hoisted_10, _toDisplayString(_ctx.$t("homeView.subheading")), 1),
      _createVNode(_component_v_row, {
        class: _normalizeClass({
        'center-content': _ctx.isLoggedIn,
      }),
        style: {"padding":"12px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, {
            variant: "elevated",
            class: "mt-5"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, { style: {"display":"flex","justify-content":"space-between","align-items":"center"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { style: {"display":"flex"} }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_img, {
                        src: "/img1.jpg",
                        height: "300"
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { style: {"display":"flex"} }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$t("homeView.benefit1")), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_card, {
            variant: "elevated",
            class: "mt-5"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, { style: {"display":"flex","justify-content":"space-between","align-items":"center"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { style: {"display":"flex"} }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_img, {
                        src: "/img2.jpg",
                        height: "300"
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { style: {"display":"flex"} }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.$t("homeView.benefit2")), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_card, {
            variant: "elevated",
            class: "mt-5"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, { style: {"display":"flex","justify-content":"space-between","align-items":"center"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { style: {"display":"flex"} }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_img, {
                        src: "/img3.jpg",
                        height: "300"
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { style: {"display":"flex"} }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t("homeView.benefit3")), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["class"])
    ]),
    _: 1
  }))
}